export const DEFAULT_AVATAR_URL_LIGHT =
  'https://cdn.livechat-static.com/api/file/lc/img/default/assets/user-placeholder-light.png';
